
import { withSchema } from '@websolutespa/bom-core';
import { RadioOptionBase, RadioOptionComponent } from './radio-option-base';
import { RadioOptionGroup } from './radio-option-group';

export const RadioOption: RadioOptionComponent & {
  Group: typeof RadioOptionGroup;
} = withSchema(
  RadioOptionBase,
  {
    Group: RadioOptionGroup,
  });
